<template>
  <div class="login">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-0">
            <v-card-text>
              <a :href="homepage" class="text-deco">
                <div class="pb-4">
                  <v-img width="250" :src="siteConfig.logo" class="mx-auto"></v-img>
                </div>
              </a>
              <div class="pb-3 text-center text-subtitle-1 font-weight-bold black--text">Form Lupa Password</div>
              <div class="text-subtitle-2 py-5">
                <span class="black--text">Sudah punya akun?</span>
                <router-link :to="{ name: 'login' }">
                  <span class="black--text font-weight-bold pl-2">Login di sini</span>
                </router-link>
              </div>
              <v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text"
                dismissible>{{ alerts.message }}</v-alert>
              <v-form ref="formLogin" role="form" v-on:submit.prevent="onSubmit">
                <div>
                  <div class="text-subtitle-2 black--text pb-1">No. Hp</div>
                  <!-- @keypress="onlyNumber" -->

                  <v-text-field @keypress="onlyNumber" color="primary" @paste="validatePaste($event)"
                    :rules="mobilephoneRules" @focus="() => fieldErrors.mobilephone = ''"
                    :error-messages="fieldErrors.mobilephone" v-model="mobilephone" validate-on-blur single-line
                    outlined class="color-primary rounded-lg" height="40" dense></v-text-field>
                </div>
                <!-- <div>
                  <div class="text-subtitle-2 black--text pb-1">Email</div>
                  <v-text-field :rules="emailRules" @focus="() => fieldErrors.email = ''"
                    :error-messages="fieldErrors.email" v-model="email" validate-on-blur single-line outlined
                    class="color-primary rounded-lg email-field" height="40" dense hide-details="auto"></v-text-field>
                </div> -->
                <div class="pt-5">
                  <v-btn v-if="isAttempting" x-large depressed color="black" class="col-12 rounded-lg white--text">
                    <div class="subtitle-2">Sedang Diproses ...</div>
                  </v-btn>
                  <v-btn v-else x-large depressed color="black" class="col-12 rounded-lg white--text" type="submit">
                    <div class="subtitle-2">Proses</div>
                  </v-btn>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      homepage: process.env.VUE_APP_HOMEPAGE,
      mobilephone: "",
      email: "",
      mobilephoneRules: [v => !!v || "Nomor Handphone tidak boleh kosong"],
      emailRules: [v => !!v || "Email tidak boleh kosong"]
    };
  },
  computed: {
    ...mapState("kiriminaja", [
      "siteConfig",
    ]),
    ...mapState("auth", ["isAttempting", "alerts", "fieldErrors"])
  },
  async beforeMount() {
    await this.getSiteConfig()
    // console.log("siteconf", this.siteConfig.favicon)
    var link = await document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = await 'image/x-icon';
    link.rel = await 'shortcut icon';
    link.href = await this.siteConfig.favicon;
    await document.getElementsByTagName('head')[0].appendChild(link);
    // console.log(" this.siteConfig.favicon", this.siteConfig.favicona)
  },
  methods: {
    ...mapActions("kiriminaja", [
      "getSiteConfig",
    ]),
    ...mapActions("auth", ["forgetPassword"]),

    async validatePaste(val) {
      let pasted = await val.clipboardData.getData("text");
      setTimeout(() => {
        if (!parseInt(pasted)) {
          this.mobilephone = "";
        }
      });
    },
    onSubmit() {
      if (this.$refs.formLogin.validate()) {
        this.forgetPassword({
          mobilephone: this.mobilephone,
          email: this.email
        }).then(() => {
          this.$router.push({
            name: "login"
          });
        });
      }
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Lupa Password");
  }
};
</script>
